import linkFallback from "../../../static/images/link_placeholder.png";
import documentFallback from "../../../static/images/document_placeholder.png";
import videoFallback from "../../../static/images/video_placeholder.png";
import { IImage, ISingleWordpressDocumentDocument } from "src/models";

export const fallbackImage = (type: string) => {
  let fallbackImage = {
    mediaItemUrl: documentFallback as string,
    url: documentFallback as string
  } as IImage;
  if (type === "link") {
    fallbackImage.mediaItemUrl = linkFallback as string;
  }
  if (type === "video") {
    fallbackImage.mediaItemUrl = videoFallback as string;
  }
  return fallbackImage;
};

export const getFallbackImage = (documents: [ISingleWordpressDocumentDocument]) => {
  const primaryDocument = documents?.find(doc => !!doc.documentFile) || documents?.[0];
  const documentType = getDocumentType(primaryDocument);
  return fallbackImage(documentType);
};

export const getDocumentType = (document: ISingleWordpressDocumentDocument) => {
  switch (true) {
    case !!document?.documentLink:
      return document.documentLinkType;
  }
  return "file";
};
